import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Text } from '@/components/ui/text';
import { type FC } from 'react';

export const ExtractionWarningModal: FC<{
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  isLoading: boolean;
  onConfirm: () => void;
}> = ({ isOpen, onOpenChange, isLoading, onConfirm }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="pr-1">
            Re-run extraction for all papers?
          </DialogTitle>
        </DialogHeader>
        <Text>
          This will permanently delete all extracted data. Paper status will be
          preserved. Export your extraction table first if needed.
        </Text>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button onClick={onConfirm} loading={isLoading}>
            Yes, launch extraction
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
